import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import DisabledCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/DisabledCell'
import { useDropShift } from 'modules/shift_management/hooks/useDragAndDrop'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

import EmployeeDayCell from './EmployeeDayCell'
import WorkAreaDayCell from './WorkAreaDayCell'

export interface DayCellProps {
  date: moment.Moment
  shiftsRow: ShiftsRow
  visibleDefaultShifts: DefaultShifts
}

const DayCell = ({ date, shiftsRow, visibleDefaultShifts }: DayCellProps) => {
  const [{ view }] = useSchedule()

  const {
    isOver: isOverParent,
    canDrop,
    drop,
  } = useDropShift({
    shiftsRow,
    date,
  })

  if (shiftsRow.isDisabled(view, date)) {
    return <DisabledCell />
  }

  const isFirstDay = view.isDateFirstDayOfPeriod(date)

  return (
    <Box
      flexDirection="column"
      height="full"
      flexGrow
      gap="s4"
      padding="s4"
      paddingBottom="s8"
      ref={drop}
    >
      {view.isByAreas ? (
        <WorkAreaDayCell
          date={date}
          shiftsRow={shiftsRow}
          isFirstDay={isFirstDay}
          visibleDefaultShifts={visibleDefaultShifts}
        />
      ) : (
        <EmployeeDayCell
          date={date}
          shiftsRow={shiftsRow}
          isFirstDay={isFirstDay}
          isOver={canDrop && isOverParent}
          visibleDefaultShifts={visibleDefaultShifts}
        />
      )}
    </Box>
  )
}

export default observer(DayCell)
